// extracted by mini-css-extract-plugin
export var hVidContainer = "Hero1-module--h-vid-container--e49ed";
export var heroOverlay = "Hero1-module--hero-overlay--f3747";